import { CircularProgress } from '@mui/material';
import { WidgetSpacer } from './WidgetSpacer';

export function LoadingSpinner() {
  return (
    <WidgetSpacer>
      <CircularProgress />
    </WidgetSpacer>
  );
}
